import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.component";
import Nosotros from './pages/Nosotros/Nosotros';
import Equipo from './pages/Equipo/Equipo';
import Servicios from './pages/Servicios/Servicios';
import Usados from './pages/Usados/Usados';
import ZeroKM from './pages/ZeroKM/ZeroKM';
import Motos from './pages/Motos/Motos';
import Sponsors from './pages/Sponsors/Sponsors'
import NotFound from './pages/NotFound/NotFound';
import "./App.css";

function App() {
  return (
    <main>
      <BrowserRouter basename="/">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/equipo" element={<Equipo />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/usados" element={<Usados />} />
          <Route path="/0km" element={<ZeroKM />} />
          <Route path="/motos" element={<Motos />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </main>
  );
}

export default App;